import { PreOrderUserRole } from '../types'

export default function isPreOrderAttendeeUserRole(
  preOrderUserRole: PreOrderUserRole,
) {
  return preOrderUserRole === PreOrderUserRole.Attendee
}
